export const getNameFromUrl = (url: string): string => {
  const urlParser: URL = new URL(url);
  const name = urlParser.pathname.split('/').pop();

  return name;
};
